import { MouseEventHandler, ReactNode } from "react";

import {
  Alert,
  CloseButton,
  StyleProps,
  scopedTestIds,
  type TestIdProps
} from "@/storybook-components";

interface AlertsPops extends StyleProps, TestIdProps {
  title?: string | ReactNode;
  description?: string | ReactNode;
  onClose?: MouseEventHandler<HTMLButtonElement>;
  status: "warning" | "success" | "error" | "info";
}

const Alerts = ({
  title,
  status,
  onClose,
  description,
  "data-testid": rootTestId,
  ...rest
}: AlertsPops) => {
  // Root id lands on Alert.Root; the dismiss control derives `${root}-close`.
  const t = scopedTestIds(rootTestId);

  return (
    <Alert.Root status={status} {...rest} {...t.props()}>
      <Alert.Indicator />
      <Alert.Content>
        {title && <Alert.Title>{title}</Alert.Title>}
        {description && <Alert.Description>{description}</Alert.Description>}
      </Alert.Content>
      {onClose && (
        <CloseButton ml="auto" onClick={onClose} {...t.props("close")} />
      )}
    </Alert.Root>
  );
};

export default Alerts;
